import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import Section from '../Inputs/Section'
import { Divider, Form, Grid, Header } from 'semantic-ui-react'
import Select from '../Inputs/Select'
import { Conform, ConformAdequat, ConformYes, FromTo, Replace, Years, YesNo } from '../../../utils/FormSelectHelper'
import Input from '../Inputs/Input'
import Checkbox from '../Inputs/Checkbox'
import { autorun, runInAction } from 'mobx'
import Duplicate from '../Inputs/Duplicate'
import { inject, observer } from 'mobx-react'

@inject('eventsStore')
@observer
class RIGSEA000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry),
    eventsStore: PropTypes.any
  }

  handleRaccordPompierDistanceRPaBF = (label, key, value) => {
    const { equipment, eventsStore } = this.props
    const convertedValue = Number(value)
    if (convertedValue >= 45) {
      eventsStore.addNFPA(equipment.id, label, key, `${value} m`)
    } else {
      eventsStore.removeNFPA(equipment.id, key)
    }
  }

  componentDidMount () {
    const { equipment } = this.props

    this.autorun = autorun(() => {
      const residuelle = parseInt(equipment.getValue('residuelle', false, 0))
      const statique = parseInt(equipment.getValue('statique', false, 0))
      if (statique > 0) {
        runInAction(() => {
          equipment.updateValue('differentiel', ((residuelle * 100) / statique).toFixed(2))
        })
      }
    })
  }

  componentWillUnmount () {
    this.autorun()
  }

  render () {
    const { equipment } = this.props

    return (
      <>
        <Form>
          <Section title={(<Header as='h2'>1. IDENTIFICATION DE L'ÉQUIPEMENT</Header>)} name='1naCheckbox' equipment={equipment}>
            <Form.Group widths='equal'>
              <Select name='batimentMemeVocation' formEntry={equipment} options={YesNo()} isFixed label='1.1 Bâtiment a-t-il la même vocation' />
              <Select name='annee' formEntry={equipment} options={Years()} isRequired label='1.8 Année' />
              <Select name='robinetSecteur' formEntry={equipment} options={FromTo(1, 100)} isRequired label='1.15 Robinet de secteur (voir composantes) (Qté)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='localisation' formEntry={equipment} isRequired label='1.2 Localisation' />
              <Select
                name='diametre' formEntry={equipment} options={[
                  { value: '1', text: '1' },
                  { value: '1.25', text: '1.25' },
                  { value: '1.5', text: '1.5' },
                  { value: '2', text: '2' },
                  { value: '2.5', text: '2.5' },
                  { value: '3', text: '3' },
                  { value: '4', text: '4' },
                  { value: '6', text: '6' },
                  { value: '8', text: '8' },
                  { value: '10', text: '10' },
                  { value: '12', text: '12' }
                ]} isRequired label='1.9 Diamètre (po)'
              />
              <Select name='robinetArmesAuxEtages' formEntry={equipment} options={FromTo(1, 100)} isRequired label='1.16 Robinets armés 2 1/2" aux étages (Qté)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='numSysteme' formEntry={equipment} isRequired label='1.3 Numéro du système' />
              <Select name='plaqueSignaletique' formEntry={equipment} isFixed options={Conform()} label='1.10 Plaque signalétique' />
              <Select name='surveillanceRobinet' formEntry={equipment} options={Conform()} isRequired label='1.17 Surveillance des robinets' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='zoneProtege' formEntry={equipment} isRequired label='1.4 Zone protégé' />
              <Select name='panneauInfoGeneral' formEntry={equipment} isFixed options={Conform()} label="1.11 Panneau d'information général" />
              <Select
                name='typeInterrupteurAlarm' formEntry={equipment} options={[
                  { value: 'ps101', text: 'PS-10-1' },
                  { value: 'eps101', text: 'EPS10-1' },
                  { value: 'ps102', text: 'PS10-2' },
                  { value: 'eps102', text: 'EPS10-2' },
                  { value: 'vsr', text: 'VSR"' },
                  { value: 'wfs5', text: 'WFS-5' },
                  { value: 'other', text: 'Autres' }
                ]} isRequired label="1.18 Type d'interrupteur d'alarme"
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select
                name='marque' formEntry={equipment} options={[
                  { value: 'Viking', text: 'Viking' },
                  { value: 'Tyco', text: 'Tyco' },
                  { value: 'Grinnell', text: 'Grinnell' },
                  { value: 'Gem', text: 'Gem' },
                  { value: 'Reliable', text: 'Reliable' },
                  { value: 'Victaulic', text: 'Victaulic' },
                  { value: 'Astra', text: 'Astra' },
                  { value: 'Hodgman', text: 'Hodgman' },
                  { value: 'Star', text: 'Star' }
                ]} isRequired label='1.5 Marque'
              />
              <Select name='idenTuyauterie' formEntry={equipment} isFixed options={Conform()} label='1.12 Identification de la tuyauterie' />
              <Select
                name='interrupteurPression2' formEntry={equipment} options={[
                  { value: 'ps1201', text: 'PS120-1' },
                  { value: 'ps1202', text: 'PS120-2' },
                  { value: 'esp1201', text: 'ESP120-1' },
                  { value: 'esp1202', text: 'ESP120-2' },
                  { value: 'other', text: 'Autres' }
                ]} isRequired label='1.17 Interrupteur haute et basse pression'
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='modele' formEntry={equipment} isRequired label='1.6 Modèle' />
              <Select name='idenComposantes' formEntry={equipment} isFixed options={Conform()} label='1.13 Identification des composantes' />
              <Input name='empalcementRobinetEssai' formEntry={equipment} isRequired label="1.20 Emplacement du robinet d'essai" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='numSerie' formEntry={equipment} isRequired label='1.7 No de série' />
              <Select name='robinetControle' formEntry={equipment} isRequired options={FromTo(1, 50)} label='1.14 Robinet de contrôle (Qté)' />
              <div className='field' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>2. VÉRIFICATION & ESSAIS</Header>)} name='2verfEssai' equipment={equipment}>
            <Form.Group widths='equal'>
              <Input name='PompeSurpression' formEntry={equipment} isRequired label='2.1 Pompe de surpression' />
              <Input name='compresseurAutomatique' className='second-title' formEntry={equipment} isFixed label='2.1.3 Automatique (de - à)' />
              <Select name='verificationEssaiDisjoncteurMural' className='second-title' formEntry={equipment} isRequired options={Replace()} label='2.1.6 Disjoncteur mural' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='verificationEssaiMarque' className='second-title' formEntry={equipment} options={[{ value: 'albany', text: 'Albany' }]} isRequired label='2.1.1 Marque' />
              <Select name='verificationEssaiConditionBoyaux' className='second-title' formEntry={equipment} options={Replace()} isFixed label='2.1.4 Condition des boyaux' />
              <Select name='delaiPompage' className='second-title' formEntry={equipment} isRequired options={FromTo(1, 90)} label='2.1.7 Délai de pompage (min.)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='verificationEssaiHP' className='second-title' formEntry={equipment} options={[{ value: '1/3', text: '1/3' }, { value: '1/2', text: '1/2' }]} isRequired label='2.1.2 HP' />
              <Select name='verificationEssaiCommandePression' className='second-title' formEntry={equipment} options={Replace()} isRequired label='2.1.5 Commande de pression' />
              <Select name='verificationEssaiSoupapeSurete' className='second-title' formEntry={equipment} isRequired options={Replace()} label='2.1.8 Soupape de sureté' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <div className='field' />
              <Select name='verificationEssaiFonctionnement' className='second-title' formEntry={equipment} isRequired options={Replace()} label='2.1.9 Fonctionnement' />
            </Form.Group>
            <Divider className='dashed' />
            <Form.Group widths='equal'>
              <Select name='manometre' formEntry={equipment} options={Years()} isRequired label='2.2 Manomètre' />
              <Select name='essaiRobinetEssai' formEntry={equipment} options={YesNo()} isRequired label="2.5 Essai du robinet d'essai" />
              <Select name='avertisseurElectriqueFonctionnel' formEntry={equipment} options={ConformYes()} isRequired label='2.8 Avertisseur électrique fonctionnel' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='manometreEtat' className='second-title' formEntry={equipment} options={Conform()} isRequired label='2.2.1 État' />
              <Select name='orifice' className='second-title' formEntry={equipment} options={Conform()} isFixed label='2.5.1 Orifice' />
              <Select name='essaiDrainPrincipal' formEntry={equipment} options={ConformYes()} label='2.9 Essai drain principal' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='pressionDernierEtage' className='second-title' formEntry={equipment} options={FromTo(1, 175)} isFixed label='2.2.2 Pression au dernier étage (psi)' />
              <Select name='conditionTuyauterieAccessoire' formEntry={equipment} options={ConformAdequat()} isRequired label="2.5.1 Condition tuyauterie d'accessoire" />
              <Select name='residuelle' className='second-title' formEntry={equipment} isFixed options={FromTo(0, 150)} label='2.9.1 Résiduelle (psi)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='operationRobinetControle' formEntry={equipment} options={ConformAdequat()} isRequired label='2.3 Opération du robinet de contrôle' />
              <Select name='avertisseurHydrauliqueFonctionnel' formEntry={equipment} options={ConformYes()} isFixed label='2.7 Avertisseur hydraulique fonctionnel' />
              <Select name='statique' className='second-title' formEntry={equipment} isFixed options={FromTo(0, 175)} label='2.9.2 Statique (psi)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='operationRobinetSecteur' formEntry={equipment} options={ConformAdequat()} isRequired label='2.4 Opération des robinets de secteur' />
              <Select name='tamis' className='second-title' formEntry={equipment} options={ConformAdequat()} isFixed label='2.7.1 Tamis' />
              <Input name='differentiel' className='second-title' formEntry={equipment} isFixed label='2.9.3 Différientiel (%)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <div className='field' />
              <Select name='drainageAdequat' formEntry={equipment} options={ConformYes()} isRequired label='2.10 Drainage adéquat' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>3. BOUCLE ANTI-GEL</Header>)} name='3boucAntiGel' equipment={equipment}>
            <Form.Group widths='equal'>
              <Input name='boucleAntiGelEmplacement' formEntry={equipment} isRequired label='3.1 Emplacement' />
              <Select name='boucleAntiGelDARPR' formEntry={equipment} options={YesNo()} isRequired label='3.3 D.A.R.P.R.' />
              <Select name='boucleAntiGelReservoirExpansion' formEntry={equipment} options={ConformYes()} isRequired label="3.4 Réservoir d'expansion" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='boucleAntiGelInstallation' formEntry={equipment} options={ConformAdequat()} isRequired label='3.2 Installation' />
              <Select name='boucleAntiGelVolumeAdequat' formEntry={equipment} options={ConformYes()} isRequired label='3.3.1 Volume adéquat' />
              <Select name='boucleAntiGelProduitUtilise' formEntry={equipment} options={Conform()} isRequired label='3.5 Produit utilisé' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <div className='field' />
              <Select name='boucleAntiGelTemperatureNiveauGel' formEntry={equipment} options={FromTo(0, -50, -1)} isFixed label='3.6 Température du niveau de gel (deg.)' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>5. TUYAUTERIE</Header>)} name='5tuyauterie' equipment={equipment}>
            <Form.Group widths='equal'>
              <Select name='tuyauConditionExterne' formEntry={equipment} options={ConformAdequat()} isFixed label='5.1 Condition externe' />
              <Input name='tuyauVerificationInterneRequise' formEntry={equipment} isRequired label='5.5 Vérification interne requise' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tuyauSupportNombreSuffisant' formEntry={equipment} options={ConformYes()} isFixed label='5.2 Support en nombre suffisant' />
              <Select name='tuyauVerificationQuinquennale' className='second-title' formEntry={equipment} options={YesNo()} isRequired label='5.5.1 Vérification quinquennale' />
              <Select name='tuyauInvestigationObstruction' className='second-title' formEntry={equipment} options={YesNo()} isRequired label="5.5.2 Investigation d'obstruction" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tuyauSupportBonneCondition' formEntry={equipment} options={ConformYes()} isFixed label='5.3 Support en bonne condition' />
              <Select name='tuyauVerificationQuinquennaleDerniere' className='second-title' formEntry={equipment} options={Years()} isRequired label='5.5.1.1 Dernière (année)' />
              <Select name='tuyauInvestigationObstructionDerniere' className='second-title' formEntry={equipment} options={Years()} isRequired label='5.5.2.1 Dernière (année)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='tuyauSupportSismique' formEntry={equipment} options={ConformYes()} isFixed label='5.4 Support sismique' />
              <Select name='tuyauVerificationQuinquennaleProchaine' className='second-title' formEntry={equipment} options={Years()} isRequired label='5.5.1.2 Prochaine (année)' />
              <Select name='tuyauInvestigationObstructionProchaine' className='second-title' formEntry={equipment} options={Years()} isRequired label='5.5.2.2 Prochaine (année)' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>6. GICLEUR</Header>)} name='6gicleur' equipment={equipment}>
            <Grid>
              <Grid.Row>
                <Grid.Column width='4'>
                  <Select name='gicleurNombreApproximatif' formEntry={equipment} options={FromTo(0, 1000, 10)} isRequired label='6.1 Nombre approximatif' />
                </Grid.Column>
                <Grid.Column width='3' />
                <Grid.Column width='9'>
                  <Select name='gicleurTemperatureDeclenchement' formEntry={equipment} options={ConformAdequat()} isRequired label='6.6 Température de déclenchement' />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width='4'>
                  <Select name='gicleurSupplementairesAccessible' formEntry={equipment} options={ConformYes()} isFixed label='6.2 Supplémentaires accessibles' />
                  <Select name='gicleurClefGicleur' className='second-title' formEntry={equipment} options={ConformYes()} isFixed label='6.3 Clef de gicleur' />
                  <Select name='gicleurConditionGicleur' className='second-title' formEntry={equipment} options={ConformAdequat()} isFixed label='6.4 Condition des gicleurs' />
                  <Select name='gicleurLibreObstruction' className='second-title' formEntry={equipment} options={ConformYes()} isRequired label="6.5 Libre d'obstruction" />
                </Grid.Column>
                <Grid.Column width='3' />
                <Grid.Column width='3'>
                  <Header as='h5' color='red'>PENDANT</Header>
                  <Checkbox name='gicleurPendant135' formEntry={equipment} label='135&deg;F' />
                  <Checkbox name='gicleurPendant155' formEntry={equipment} label='155&deg;F' />
                  <Checkbox name='gicleurPendant174' formEntry={equipment} label='174&deg;F' />
                  <Checkbox name='gicleurPendant200' formEntry={equipment} label='200&deg;F' />
                  <Checkbox name='gicleurPendant286' formEntry={equipment} label='286&deg;F' />
                  <Checkbox name='gicleurPendant360' formEntry={equipment} label='360&deg;F' />
                  <Checkbox name='gicleurPendant500' formEntry={equipment} label='500&deg;F' />
                </Grid.Column>
                <Grid.Column width='3'>
                  <Header as='h5' color='red'>DEBOUT</Header>
                  <Checkbox name='gicleurDebout135' formEntry={equipment} label='135&deg;F' />
                  <Checkbox name='gicleurDebout155' formEntry={equipment} label='155&deg;F' />
                  <Checkbox name='gicleurDebout174' formEntry={equipment} label='174&deg;F' />
                  <Checkbox name='gicleurDebout200' formEntry={equipment} label='200&deg;F' />
                  <Checkbox name='gicleurDebout286' formEntry={equipment} label='286&deg;F' />
                  <Checkbox name='gicleurDebout360' formEntry={equipment} label='360&deg;F' />
                  <Checkbox name='gicleurDebout500' formEntry={equipment} label='500&deg;F' />
                </Grid.Column>
                <Grid.Column width='3'>
                  <Header as='h5' color='red'>MURAL</Header>
                  <Checkbox name='gicleurMural135' formEntry={equipment} label='135&deg;F' />
                  <Checkbox name='gicleurMural155' formEntry={equipment} label='155&deg;F' />
                  <Checkbox name='gicleurMural174' formEntry={equipment} label='174&deg;F' />
                  <Checkbox name='gicleurMural200' formEntry={equipment} label='200&deg;F' />
                  <Checkbox name='gicleurMural286' formEntry={equipment} label='286&deg;F' />
                  <Checkbox name='gicleurMural360' formEntry={equipment} label='360&deg;F' />
                  <Checkbox name='gicleurMural500' formEntry={equipment} label='500&deg;F' />
                </Grid.Column>
              </Grid.Row>
              <Divider className='dashed' />
              <Grid.Row stretched>
                <Grid.Column width='4'>
                  <Header as='h5'>6.7 Type de gicleur</Header>
                  <Select name='gicleurStandardMoins50Ans' formEntry={equipment} options={ConformYes()} isRequired label='6.7.1 Standard moins de 50 ans' />
                  <Select name='gicleurResidentielMoins50Ans' formEntry={equipment} options={ConformYes()} isRequired label='6.7.2 Résidentiel moins de 20 ans' />
                  <Select name='gicleurRepRapideMoins50Ans' formEntry={equipment} options={ConformYes()} isRequired label='6.7.3 Rép. Rapide moins de 20 ans' />
                  <Select name='gicleurSecMoins10Ans' formEntry={equipment} options={ConformYes()} isRequired label='6.7.4 Sec moins de 10 ans' />
                  <Select name='gicleurTHMoins5Ans' formEntry={equipment} options={YesNo()} isRequired label='6.7.5 T.H. temp. moins de 5 ans' />
                </Grid.Column>
                <Grid.Column width='3' />
                <Grid.Column width='9' verticalAlign='bottom'>
                  <Select name='gicleurEchantillonageGicleurRectification' formEntry={equipment} options={YesNo()} isFixed label='6.8 Échantillonage de gicleur pour recertification' />
                  <Input name='gicleurSection' className='second-title' formEntry={equipment} isFixed label='6.8.1 Section' />
                  <Select name='gicleurQuantite' className='second-title' formEntry={equipment} isFixed options={FromTo(4, 100)} label='6.8.2 Quantité (1% ou min. 4)' />
                  <Select name='gicleurSectionsBatimentProtege' formEntry={equipment} options={YesNo()} isRequired label='6.9 Toutes les sections du bâtiments sont protégées adéquatement' />
                  <Select name='gicleurDegagementMinimal' formEntry={equipment} options={YesNo()} isRequired label='6.10 Dégagement minimal et maximal des gicleurs sont respectés' />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Section>
          <Section title={(<Header as='h2'>7. PROTECTION DE FEUX DE VOISINAGE</Header>)} name='7protectionFeux' equipment={equipment}>
            <Form.Group widths='equal'>
              <Input name='ProtectionFeuxVoisinageLocalisation' formEntry={equipment} isRequired label='7.1 Localisation' />
              <Select name='ProtectionFeuxVoisinageGicleurConditionNormaleOperation' formEntry={equipment} options={ConformYes()} isFixed label="7.4 Gicleurs en condition normale d'opération" />
              <Select name='ProtectionFeuxVoisinageSupport' className='second-title' formEntry={equipment} options={ConformYes()} isRequired label='7.5.2 Support' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='ProtectionFeuxVoisinageValveSecteurNormalementFermeSupervise' formEntry={equipment} options={ConformYes()} isRequired label='7.2 Valve de secteur normalement fermé et supervisé' />
              <Select name='ProtectionFeuxVoisinageDispositionGicleurAdequate' className='second-title' formEntry={equipment} options={ConformYes()} isFixed label='7.4.1 Disposition des gicleurs adéquate' />
              <Select name='ProtectionFeuxVoisinageEssaiEcoulement' formEntry={equipment} options={ConformYes()} isFixed label="7.6 Essai d'écoulement" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='ProtectionFeuxVoisinageManometre' formEntry={equipment} options={Years()} isRequired label='7.3 Manomètre (a.)' />
              <Select name='ProtectionFeuxVoisinageTuyauterieSupportAdequat' formEntry={equipment} options={ConformYes()} isRequired label='7.5 Tuyauterie et support adéquats' />
              <Select name='ProtectionFeuxVoisinageAnnee' className='second-title' formEntry={equipment} options={Years()} isFixed label='7.6.1 Année (a.)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Select name='ProtectionFeuxVoisinageTuyauterieMatiereNonCorrosive' className='second-title' formEntry={equipment} options={ConformYes()} isRequired label='7.5.1 Tuyauterie en matière non-corrosive)' />
              <Select name='ProtectionFeuxVoisinageDrainage' formEntry={equipment} options={ConformAdequat()} isRequired label='7.7 Drainage' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>8. VÉRIFICATION DU RACCORD POMPIER (R.P.)</Header>)} name='8verfRaccordPompier' equipment={equipment}>
            <Duplicate
              name='raccordPompierList' btnLabel='Raccord' equipment={equipment} renderGroup={(index) => {
                return (
                  <Fragment key={`rpl${index}`}>
                    <Header as='h5'>Raccord #{index + 1}</Header>
                    <Form.Group widths='equal'>
                      <Input name={`raccordPompierLocalisation${index || ''}`} formEntry={equipment} isRequired label='8.1 Localisation' />
                      <Select name={`raccordPompierZoneDesservi${index || ''}`} options={ConformAdequat()} formEntry={equipment} isRequired label='8.6 Identification de la zone desservi' />
                      <Select name={`raccordPompierJointEtancheite${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label="8.10 Joint d'étanchéité" />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierNombrePrise${index || ''}`} options={FromTo(1, 2)} formEntry={equipment} isRequired label='8.2 Nombre de prise' />
                      <Select name={`raccordPompierAccessibilite${index || ''}`} options={ConformAdequat()} formEntry={equipment} isRequired label='8.7 Accessibilité' />
                      <Select name={`raccordPompierPlaquetteIdentification${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label="8.11 Plaquette d'identification" />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierTypeRP${index || ''}`} options={[{ value: 'encastre', text: 'Encastré' }, { value: 'surface', text: 'Surface' }, { value: 'storz', text: 'Storz' }, { value: 'vertical', text: 'Vertical' }]} formEntry={equipment} isRequired label='8.3 Type de R.P.' />
                      <Select name={`raccordPompierRotationSortieAmont${index || ''}`} options={ConformAdequat()} formEntry={equipment} isFixed label='8.8 Rotations des sorties en amont' />
                      <Select name={`raccordPompierClapetRetenueFonctionnel${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label='8.12 Clapet de retenue fonctionnel' />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierDistanceRPaBF${index || ''}`} options={FromTo(1, 100)} formEntry={equipment} isRequired label='8.4 Distance R.P. à une B.F. (m.)' onBlur={this.handleRaccordPompierDistanceRPaBF} />
                      <Select name={`raccordPompierTypeRotation${index || ''}`} className='second-title' options={[{ value: 'qst', text: 'QST' }, { value: 'storz', text: 'storz' }, { value: 'Sherbrooke', text: 'Sherbrooke' }]} formEntry={equipment} isRequired label='8.8.1 Type de rotations' />
                      <Select name={`raccordPompierBilleEgoutementPresente${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label="8.13 Bille d'égoutement présente" />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Select name={`raccordPompierVisibilite${index || ''}`} options={ConformAdequat()} formEntry={equipment} isFixed label='8.5 Visibilité' />
                      <Select name={`raccordPompierBouchonOuCapuchonPresent${index || ''}`} options={ConformYes()} formEntry={equipment} isFixed label='8.9 Bouchons ou capuchons présent' />
                      <Select name={`raccordPompierPivotFonctionnel${index || ''}`} options={ConformYes()} formEntry={equipment} isRequired label='8.14 Le pivot est fonctionnel' />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <div className='field' />
                      <div className='field' />
                      <Select name={`raccordPompierConditionInterne${index || ''}`} options={ConformAdequat()} formEntry={equipment} isRequired label='8.15 Condition interne' />
                    </Form.Group>
                  </Fragment>
                )
              }}
            />
          </Section>
          <Section
            title={(<Header as='h2'>11. BASSIN - RÉSERVOIR</Header>)}
            secondaryField={(<Select name='bassinReservoirType' formEntry={equipment} options={[{ value: 'bassin', text: 'Bassin' }, { value: 'reservoir', text: 'Réservoir' }]} />)}
            name='11bassinReservoir' equipment={equipment}
          >
            <Header as='h5'>11.1 Inspection / maintenance</Header>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinNiveauDeau' options={ConformAdequat()} formEntry={equipment} isFixed label="11.1.1 Niveau d'eau" />
              <Select name='reservoirBassinConditionExterne' options={ConformAdequat()} formEntry={equipment} isFixed label='11.1.6 Condition externe' />
              <Select name='reservoirBassinClapetRetenue' options={ConformAdequat()} formEntry={equipment} isRequired label='11.1.11 Clapet de retenue' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinTemperatureEau' options={ConformAdequat()} formEntry={equipment} isFixed label="11.1.2 Température de l'eau" />
              <Select name='reservoirBassinSupportStructure' options={ConformAdequat()} formEntry={equipment} isRequired label='11.1.7 Support et structure' />
              <Select name='reservoirBassinTamisFiltresOrifices' options={ConformAdequat()} formEntry={equipment} isRequired label='11.1.12 Tamis, filtres et orifices' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinSystemeChauffage' options={ConformAdequat()} formEntry={equipment} isFixed label='11.1.3 Système de chauffage' />
              <Select name='reservoirBassinPasserelleEchelle' options={ConformAdequat()} formEntry={equipment} isRequired label='11.1.8 Passerelles et échelles' />
              <Select name='reservoirBassinLocalSoupape' options={ConformAdequat()} formEntry={equipment} isRequired label='11.1.13 Local des soupapes' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinValveControle' options={ConformAdequat()} formEntry={equipment} isFixed label='11.1.4 Valve de contrôle' />
              <Select name='reservoirBassinJointsExpansion' options={ConformAdequat()} formEntry={equipment} isRequired label="11.1.9 Joints d'expansion" />
              <Select name='reservoirBassinTuyauterieTropPlein' options={ConformAdequat()} formEntry={equipment} isRequired label='11.1.14 Tuyauterie de trop plein' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinPressionAir' options={FromTo(0, 200)} formEntry={equipment} isFixed label="11.1.5 Pression d'air (psi)" />
              <Select name='reservoirBassinIntérieur' options={ConformAdequat()} formEntry={equipment} isRequired label='11.1.10 Intérieur' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Select name='reservoirBassinIntérieurInterne' className='second-title' options={Years()} formEntry={equipment} isRequired label='11.1.10.1 Dernière vérification interne' />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Select name='reservoirBassinIntérieurExterne' className='second-title' options={Years()} formEntry={equipment} isRequired label='11.1.10.2 Dernière vérification externe' />
              <div className='field' />
            </Form.Group>
            <Divider className='dashed' />
            <Header as='h5'>11.2 Test</Header>
            <Form.Group widths='equal'>
              <Input name='reservoirBassinAlarmesHauteBasseTemperature' formEntry={equipment} isFixed label='11.2.1" Alarmes de haute/basse température (&deg;C)' />
              <Select name='reservoirBassinAlarmeBasNiveau' options={ConformAdequat()} formEntry={equipment} isFixed label='11.2.4 Alarme de bas niveau' />
              <Select name='reservoirBassinInterrupteurValveAutomatique' options={ConformYes()} formEntry={equipment} isFixed label='11.2.7 Interrupteur de la valve automatique' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinInterrupteurSystemeChauffage' options={ConformAdequat()} formEntry={equipment} isFixed label='11.2.2 Interrupteur du système de chauffage' />
              <Select name='reservoirBassinIndicateurNiveau' options={ConformAdequat()} formEntry={equipment} isFixed label='11.2.5 Indicateur de niveau' />
              <Select name='reservoirBassinOperationValveAutomatique' options={ConformYes()} formEntry={equipment} isFixed label='11.2.8 Opération de la valve automatique' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='reservoirBassinAlarmeHautNiveau' options={ConformAdequat()} formEntry={equipment} isFixed label='11.2.3 Alarme de haut niveau' />
              <Select name='reservoirBassinManometre' options={Years()} formEntry={equipment} isRequired label='11.2.6 Manomètre' />
              <Select name='reservoirBassinOperationValveRemplissage' options={ConformYes()} formEntry={equipment} isFixed label='11.2.9 Opération de la valve de remplissage (manuel)' />
            </Form.Group>
          </Section>
          <Section
            title={(<Header as='h2'>12. MOUSSE</Header>)}
            secondaryField={(<Input name='mousseLocalisation' formEntry={equipment} label='Localisation' />)}
            name='12mousse' equipment={equipment}
          >
            <Header as='h5'>12.2 Réservoir</Header>
            <Form.Group widths='equal'>
              <Input name='mousseMarque' formEntry={equipment} isRequired label='12.2.1 Marque' />
              <Select name='mousseTamisFiltresOrifices' options={ConformAdequat()} formEntry={equipment} isRequired label='12.2.7 Tamis, filtres et orifices' />
              <Select name='mousseValveSolenoide' options={ConformAdequat()} formEntry={equipment} isRequired label='12.2.13 Valve solénoïde' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='mousseModele' formEntry={equipment} isRequired label='12.2.2 Modèle' />
              <Select name='mousseEvent' options={ConformAdequat()} formEntry={equipment} isFixed label='12.2.8 Évent' />
              <Select name='mousseManometre' options={Years()} formEntry={equipment} isRequired label='12.2.14 Manomètre' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='mousseAnnee' options={Years()} formEntry={equipment} isRequired label='12.2.3 Année' />
              <Select name='mousseNiveauMousee' options={ConformAdequat()} formEntry={equipment} isFixed label='12.2.9 Niveau de la mousse' />
              <Select name='mousseDrainageAdequat' options={ConformYes()} formEntry={equipment} isRequired label='12.2.15 Drainage adéquat' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='mousseCapacite' formEntry={equipment} isRequired label='12.2.4 Capacité' />
              <Select name='mousseRobinetDechargeMousse' options={ConformAdequat()} formEntry={equipment} isFixed label='12.2.10 Robinet de décharge de la mousse' />
              <Input name='mousseType' formEntry={equipment} isRequired label='12.2.16 Type de réservoir' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='moussePompeInjection' options={ConformAdequat()} formEntry={equipment} isRequired label='12.2.5 Pompe à injection' />
              <Input name='mousseTypeValve' className='second-title' formEntry={equipment} isFixed label='12.2.10.1 Type de valve' />
              <Select name='mousseVerticaleHorizontale' className='second-title' options={[{ value: 'verticale', text: 'Verticale' }, { value: 'horizontale', text: 'Horizontale' }]} formEntry={equipment} isRequired label='12.2.16.1 Verticale ou horizontale' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='mousseSoupapeSurete' className='second-title' options={ConformAdequat()} formEntry={equipment} isRequired label='12.2.5.1 Soupape de sûreté' />
              <Input name='mousseActivationValve' className='second-title' formEntry={equipment} isRequired label='12.2.10.2 Activation de la valve' />
              <Select name='moussePressuriseNonPress' className='second-title' options={[{ value: 'pressurise', text: 'Pressurisé' }, { value: 'nonpressurise', text: 'Non-pressurisé' }]} formEntry={equipment} isRequired label='12.2.16.2 Pressurisé ou non-press.' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='mousseSoupapeSureteReservoir' options={ConformAdequat()} formEntry={equipment} isRequired label='12.2.6 Soupape de sûreté du réservoir' />
              <Select name='mousseRobinetIsolationMousse' options={ConformAdequat()} formEntry={equipment} isRequired label="12.2.11 Robinet d'isolation de la mousse" />
              <Input name='moussePression' className='second-title' formEntry={equipment} isRequired label='12.2.16.3 Pression' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Select name='mousseTuyauterieAlimentationMousse' options={ConformAdequat()} formEntry={equipment} isFixed label="12.2.12 Tuyauterie d'alimentation de la mousse" />
              <Input name='mousseRobinetControleAlimentationEauReservoir' formEntry={equipment} isRequired label="12.2.17 Robinet de contrôle d'alimentation en eau du réservoir" />
            </Form.Group>
            <Divider className='dashed' />
            <Header as='h5'>12.3 Proportionneur</Header>
            <Form.Group widths='equal'>
              <Input name='mousseProportionneurMarque' formEntry={equipment} isRequired label='12.3.1 Marque' />
              <Input name='mousseProportionneurModele' formEntry={equipment} isRequired label='12.3.2 Modèle' />
              <Input name='mousseProportionneurDiametre' formEntry={equipment} isRequired label='12.3.3 Diamètre (x/y)' />
            </Form.Group>
            <Divider className='dashed' />
            <Header as='h5'>12.4 Échantillonnage</Header>
            <Form.Group widths='equal'>
              <Select name='mousseEchantillonnageTypeMousse' formEntry={equipment} options={[{ value: 'AFFF', text: 'AFFF' }, { value: 'autre', text: 'autres' }]} isRequired label='12.4.1 Type de mousse' />
              <Input name='mousseEchantillonnageConcentré' formEntry={equipment} isRequired label='12.4.2 Concentré' />
              <Input name='mousseEchantillonnageSortieProportionneur' formEntry={equipment} isRequired label='12.4.3 À la sortie du proportionneur' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Input name='mousseEchantillonnageAnneeMois' className='second-title' formEntry={equipment} isRequired label='12.4.2.1 Année/mois' />
              <Input name='mousseEchantillonnageAnneeMois2' className='second-title' formEntry={equipment} isRequired label='12.4.3.1 Année/mois' />
            </Form.Group>
            <Form.Group widths='equal'>
              <div className='field' />
              <Input name='mousseEchantillonnageLieuxPriseEchantillion' className='second-title' formEntry={equipment} isRequired label='12.4.2.2 Lieux de la prise d’échantilion' />
              <div className='field' />
            </Form.Group>
          </Section>
          <Section title={(<Header as='h2'>13. VALVE RÉGULATRICE DE PRESSION</Header>)} name='13valveRegPression' equipment={equipment}>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionValveMaitresse' formEntry={equipment} options={YesNo()} isRequired label='13.1 Valve maîtresse' />
              <Select name='valveRegulatricePressionSoupapeSurete' formEntry={equipment} options={ConformAdequat()} isRequired label='13.1.10 Soupape de sûreté' />
              <Select name='valveRegulatricePressionAccouplement' formEntry={equipment} options={ConformAdequat()} isFixed label='13.5.2 Accouplement' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='valveRegulatricePressionMarque' formEntry={equipment} isRequired label='13.1.1 Marque' />
              <Select name='valveRegulatricePressionManometre' formEntry={equipment} options={Years()} isRequired label='13.1.11 Manomètre' />
              <Input name='valveRegulatricePressionFuite' formEntry={equipment} isFixed label='13.5.3 Fuite' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='valveRegulatricePressionModele' formEntry={equipment} isRequired label='13.1.2 Modèle' />
              <Select name='valveRegulatricePressionEssaiPartielEffectue' formEntry={equipment} options={ConformYes()} isFixed label='13.1.12 Essai partiel effectué (voir tableau)' />
              <Select name='valveRegulatricePressionReducteurBouchon' formEntry={equipment} options={ConformAdequat()} isFixed label='13.5.4 Réducteur et bouchon' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Input name='valveRegulatricePressionNoSerie' formEntry={equipment} isRequired label='13.1.3 No de série' />
              <Select name='valveRegulatricePressionEssaiEcoulement' formEntry={equipment} options={ConformYes()} isFixed label='13.1.13 Essai d’écoulement (voir tableau)' />
              <Select name='valveRegulatricePressionSoupapeSurete' formEntry={equipment} options={ConformAdequat()} isRequired label='13.6 Soupape de sûreté' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionAnnee' formEntry={equipment} options={Years()} isRequired label='13.1.4 Année' />
              <Select
                name='valveRegulatricePressionValveSecondaire' formEntry={equipment} options={[
                  { value: 'gicleur', text: 'Système de gicleur' },
                  { value: 'robinet', text: 'Robinets armés' },
                  { value: 'boyeaux', text: 'Boyaux incendie' }
                ]} isRequired label='13.2 Valve secondaire'
              />
              <Select name='valveRegulatricePressionEssaiPartielEffectue2' formEntry={equipment} options={ConformYes()} isFixed label='13.7 Essai partiel effectué (voir tableau)' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionDiametre' formEntry={equipment} options={FromTo(1, 12)} isRequired label='13.1.5 Diamètre' />
              <Select name='valveRegulatricePressionPressionEcharge' formEntry={equipment} isFixed options={FromTo(0, 175)} label='13.3 Pression décharge' />
              <Select name='valveRegulatricePressionEssaiDecoulement2' formEntry={equipment} options={ConformYes()} isFixed label="13.8 Essai d'écoulement (voir tableau)" />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionPressionAjustementIndiquee' formEntry={equipment} isRequired options={FromTo(0, 175)} label="13.1.6 Pression d'ajustement indiquée" />
              <Select name='valveRegulatricePressionPressionSuccion' formEntry={equipment} isFixed options={FromTo(0, 300)} label='13.4 Pression succion' />
              <Select name='valveRegulatricePressionEssaiDerniere' formEntry={equipment} options={Years()} isRequired label='13.8.1 Dernière' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionPressionDecharge2' formEntry={equipment} isFixed options={FromTo(0, 300)} label='13.1.7 Pression décharge' />
              <Select name='valveRegulatricePressionConditionValve' formEntry={equipment} options={ConformAdequat()} label='13.5 Condition de la valve' />
              <Input name='valveRegulatricePressionProchaine' formEntry={equipment} isRequired label='13.8.2 Prochaine' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionPressionSuccion2' formEntry={equipment} isFixed options={FromTo(0, 300)} label='13.1.8 Pression succion' />
              <Select name='valveRegulatricePressionConditionOperation' formEntry={equipment} options={ConformAdequat()} isFixed label="13.5.1 Condition d'opération" />
              <div className='field' />
            </Form.Group>
            <Form.Group widths='equal'>
              <Select name='valveRegulatricePressionConditionValve2' formEntry={equipment} options={ConformAdequat()} isFixed label='13.1.9 Condition de la valve' />
              <Input name='valveRegulatricePressionEtat' formEntry={equipment} isFixed label='13.5.1.1 État' />
              <div className='field' />
            </Form.Group>
          </Section>
        </Form>
      </>
    )
  }
}

RIGSEA000.fieldsRequired = [
  {
    section: '1naCheckbox',
    fields: [
      'annee',
      'robinetSecteur',
      'localisation',
      'diametre',
      'robinetArmesAuxEtages',
      'numSysteme',
      'surveillanceRobinet',
      'zoneProtege',
      'typeInterrupteurAlarm',
      'marque',
      'interrupteurPression2',
      'modele',
      'empalcementRobinetEssai',
      'numSerie',
      'robinetControle'
    ]
  }, {
    section: '2verfEssai',
    fields: ['PompeSurpression',
      'verificationEssaiDisjoncteurMural',
      'verificationEssaiMarque',
      'delaiPompage',
      'verificationEssaiHP',
      'verificationEssaiCommandePression',
      'verificationEssaiSoupapeSurete',
      'verificationEssaiFonctionnement',
      'manometre',
      'essaiRobinetEssai',
      'avertisseurElectriqueFonctionnel',
      'manometreEtat',
      'conditionTuyauterieAccessoire',
      'operationRobinetControle',
      'operationRobinetSecteur',
      'drainageAdequat']
  }, {
    section: '3boucAntiGel',
    fields: [
      'boucleAntiGelEmplacement',
      'boucleAntiGelDARPR',
      'boucleAntiGelReservoirExpansion',
      'boucleAntiGelInstallation',
      'boucleAntiGelVolumeAdequat',
      'boucleAntiGelProduitUtilise'
    ]
  }, {
    section: '5tuyauterie',
    fields: [
      'tuyauVerificationInterneRequise',
      'tuyauVerificationQuinquennale',
      'tuyauInvestigationObstruction',
      'tuyauVerificationQuinquennaleDerniere',
      'tuyauInvestigationObstructionDerniere',
      'tuyauVerificationQuinquennaleProchaine',
      'tuyauInvestigationObstructionProchaine'
    ]
  }, {
    section: '6gicleur',
    fields: [
      'gicleurNombreApproximatif',
      'gicleurTemperatureDeclenchement',
      'gicleurLibreObstruction',
      'gicleurStandardMoins50Ans',
      'gicleurResidentielMoins50Ans',
      'gicleurRepRapideMoins50Ans',
      'gicleurSecMoins10Ans',
      'gicleurTHMoins5Ans',
      'gicleurSectionsBatimentProtege',
      'gicleurDegagementMinimal'
    ]
  }, {
    section: '7protectionFeux',
    fields: [
      'ProtectionFeuxVoisinageLocalisation',
      'ProtectionFeuxVoisinageSupport',
      'ProtectionFeuxVoisinageValveSecteurNormalementFermeSupervise',
      'ProtectionFeuxVoisinageManometre',
      'ProtectionFeuxVoisinageTuyauterieSupportAdequat',
      'ProtectionFeuxVoisinageTuyauterieMatiereNonCorrosive',
      'ProtectionFeuxVoisinageDrainage'
    ]
  }, {
    section: '11bassinReservoir',
    fields: [
      'reservoirBassinClapetRetenue',
      'reservoirBassinSupportStructure',
      'reservoirBassinTamisFiltresOrifices',
      'reservoirBassinPasserelleEchelle',
      'reservoirBassinLocalSoupape',
      'reservoirBassinJointsExpansion',
      'reservoirBassinTuyauterieTropPlein',
      'reservoirBassinIntérieur',
      'reservoirBassinIntérieurInterne',
      'reservoirBassinIntérieurExterne',
      'reservoirBassinManometre'
    ]
  }, {
    section: '12mousse',
    fields: [
      'mousseMarque',
      'mousseTamisFiltresOrifices',
      'mousseValveSolenoide',
      'mousseModele',
      'mousseManometre',
      'mousseAnnee',
      'mousseDrainageAdequat',
      'mousseCapacite',
      'mousseType',
      'moussePompeInjection',
      'mousseSoupapeSurete',
      'mousseActivationValve',
      'mousseSoupapeSureteReservoir',
      'mousseRobinetIsolationMousse',
      'moussePression',
      'mousseRobinetControleAlimentationEauReservoir',
      'mousseProportionneurMarque',
      'mousseProportionneurModele',
      'mousseProportionneurDiametre',
      'mousseEchantillonnageTypeMousse',
      'mousseEchantillonnageConcentré',
      'mousseEchantillonnageSortieProportionneur',
      'mousseEchantillonnageAnneeMois',
      'mousseEchantillonnageAnneeMois2',
      'mousseEchantillonnageLieuxPriseEchantillion'
    ]
  }, {
    section: '13valveRegPression',
    fields: [
      'valveRegulatricePressionValveMaitresse',
      'valveRegulatricePressionSoupapeSurete',
      'valveRegulatricePressionMarque',
      'valveRegulatricePressionManometre',
      'valveRegulatricePressionModele',
      'valveRegulatricePressionNoSerie',
      'valveRegulatricePressionSoupapeSurete',
      'valveRegulatricePressionAnnee',
      'valveRegulatricePressionValveSecondaire',
      'valveRegulatricePressionDiametre',
      'valveRegulatricePressionPressionAjustementIndiquee',
      'valveRegulatricePressionEssaiDerniere',
      'valveRegulatricePressionProchaine'
    ]
  }

]

RIGSEA000.dynamicFieldsRequired = [{
  section: '8verfRaccordPompier',
  name: 'raccordPompierList',
  fields: [
    'raccordPompierLocalisation',
    'raccordPompierZoneDesservi',
    'raccordPompierJointEtancheite',
    'raccordPompierNombrePrise',
    'raccordPompierAccessibilite',
    'raccordPompierPlaquetteIdentification',
    'raccordPompierTypeRP',
    'raccordPompierRotationSortieAmont',
    'raccordPompierClapetRetenueFonctionnel',
    'raccordPompierDistanceRPaBF',
    'raccordPompierTypeRotation',
    'raccordPompierBilleEgoutementPresente',
    'raccordPompierVisibilite',
    'raccordPompierBouchonOuCapuchonPresent',
    'raccordPompierPivotFonctionnel',
    'raccordPompierConditionInterne'
  ]
}

]

export default RIGSEA000
